<template>
  <div
    class="py-1 px-2 bg-black/80 text-text-1 text-xs rounded-lg flex items-center gap-1"
  >
    <Icon
      icon="sky:ic-play-fill2"
      class="w-4 h-4"
    />
    {{ formattedDuration }}
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import dayjs from 'dayjs'
import durationPlugin from 'dayjs/plugin/duration'

dayjs.extend(durationPlugin)

const props = defineProps<{
  duration: number | string // 毫秒为单位
}>()

const formattedDuration = computed(() => {
  if (typeof props.duration === 'number') {
    return dayjs.duration(props.duration).format('mm:ss')
  }
  return props.duration
})
</script>
